export var getVideoInfo = function getVideoInfo(_ref) {
  var file = _ref.file,
    url = _ref.url;
  return new Promise(function (r, j) {
    var videoUrl = url || URL.createObjectURL(file);
    if (!videoUrl) {
      throw new Error('fail to get videoUrl！');
    }
    var elCanvas = document.createElement('canvas');
    var elVideo = document.createElement('video');
    elVideo.onseeked = function () {
      window.requestAnimationFrame(function () {
        var _a, _b;
        elCanvas.width = elVideo.videoWidth;
        elCanvas.height = elVideo.videoHeight;
        (_a = elCanvas.getContext('2d')) === null || _a === void 0 ? void 0 : _a.drawImage(elVideo, 0, 0, elCanvas.width, elCanvas.height);
        URL.revokeObjectURL(videoUrl);
        r({
          poster: elCanvas.toDataURL(),
          width: elCanvas.width,
          height: elCanvas.height,
          name: (file === null || file === void 0 ? void 0 : file.name) || ((_b = url === null || url === void 0 ? void 0 : url.match(/\/(\w+$)/)) === null || _b === void 0 ? void 0 : _b[1]) || 'unknown',
          size: (file === null || file === void 0 ? void 0 : file.size) || 0,
          fileType: (file === null || file === void 0 ? void 0 : file.type) || 'unknown'
        });
      });
    };
    elVideo.onerror = function () {
      j(elVideo.error);
      URL.revokeObjectURL(videoUrl);
    };
    elVideo.src = videoUrl;
    elVideo.load();
    elVideo.currentTime = 1;
  });
};
export var getImageInfo = function getImageInfo(ops) {
  var file = ops.file,
    url = ops.url,
    name = ops.name;
  return new Promise(function (r, j) {
    var _a;
    var src = url || URL.createObjectURL(file);
    var fileName;
    if (name) {
      fileName = name;
    } else if (url) {
      fileName = ((_a = url.match(/\/(\w+$)/)) === null || _a === void 0 ? void 0 : _a[1]) || 'unknown';
    } else if (file) {
      fileName = file.name;
    } else {
      fileName = 'unknown';
    }
    var img = new Image();
    img.onload = function () {
      r({
        name: fileName,
        url: src,
        width: img.naturalWidth,
        height: img.naturalHeight,
        size: (file === null || file === void 0 ? void 0 : file.size) || 0,
        fileType: (file === null || file === void 0 ? void 0 : file.type) || 'unknown'
      });
    };
    img.onerror = j;
    img.src = src;
  });
};